import React, {
  useReducer,
  useEffect
} from 'react';
import _ from 'underscore';

import {
  makeStyles,
} from '@material-ui/core';
import ChipInput from 'material-ui-chip-input';

import { validate } from '../../../utils/validators';

import './Input.css';

const inputReducer = (state, action) => {
  console.log(action);
  switch (action.type) {
    case 'CHANGE':
      return {
        ...state,
        value: action.val,
        isValid: validate(action.val, action.validators)
      };
    case 'TOUCH':
      return {
        ...state,
        isTouched: true
      };
    default:
      return state;
  }
};
const Chips = (props) => {
  const {
    id,
    onInput,
    validators,
    initialValue,
    initialValid,
    fullWidth,
    variant,
    label,
    placeholder,
    InputLabelProps
  } = props;

  const [inputState, dispatch] = useReducer(inputReducer, {
    value: initialValue || '',
    isValid: initialValid || false,
    isTouched: initialValid || false
  });

  const {
    value,
    isValid
  } = inputState;

  useEffect(() => {
    onInput(id, value, isValid);
  }, [id, value, isValid, onInput]);

  const changeHandler = (event) => {
    console.log('Mudou');
    console.log(event);
    dispatch({ type: 'CHANGE', val: _.uniq(value.concat(event)), validators });
  };

  const handleDeleteChip = (chip, index) => {
    console.log(chip);
    value.splice(index, 1);
    console.log(value);
    dispatch({ type: 'CHANGE', val: value, validators });
  };

  const handleAdd = async (chip) => {
    console.log(chip);
    console.log(`Vai adicionar: ${chip}`);
    if (chip !== '') {
      return true;
    }
    return false;
  };

  const useStyles = makeStyles(() => ({
    chips: {
      backgroundColor: 'white',
    }
  }));
  const classes = useStyles();

  return (
    <div>
      <ChipInput
        className={classes.chips}
        value={value}
        label={label}
        onDelete={(chip, index) => handleDeleteChip(chip, index)}
        onChange={(chips) => changeHandler(chips)}
        onBeforeAdd={(chip) => handleAdd(chip)}
        placeholder={placeholder}
        fullWidth={fullWidth}
        InputProps={{
          fullWidth,
          variant
        }}
        variant={variant}
        InputLabelProps={InputLabelProps}
      />
    </div>
  );
};
export default Chips;
